import TabViewModel from "Lib/Fs.SmartClient.Client/TabViewModel";
import { ValidationRules, ValidationController, ValidationControllerFactory, validateTrigger } from "aurelia-validation";
import { useView, autoinject, inject, Container } from 'aurelia-framework'

export default class DocEditorVMBase extends TabViewModel {
    IsEditing: boolean = false;
    IsItemEditing: boolean = false;
    Parent: any;
    IsAdding: boolean;
    ErrorList: string[];
    OriginalSource: any;
    HasOriginalSource: boolean = false;
    validationController: ValidationController;

    SetOriginalSource(originalSource: any, isAdding: boolean) {
        if (originalSource == null)
            this.HasOriginalSource = false;
        else {
            this.OriginalSource = originalSource;
            this.HasOriginalSource = true;
            this.LoadOriginalSource(originalSource, isAdding);
        }
    }
    
    constructor() {
        super();
        var validationControllerFactory = Container.instance.get(ValidationControllerFactory);
        this.validationController = validationControllerFactory.createForCurrentScope();
    }

    getValidateErrors(key: string) {
        if (this.validationController.errors.length == 0) return []
        var filter = this.validationController.errors.filter(function (t) {
            return t.propertyName === key;
        });
        if (filter.length == 0) return [];
        var map = filter.map(function (t) {
            return t.message;
        });
        return map;
    }

    getDisplayNameValidateErrors(key: string) {
        if (this.validationController.errors.length == 0) return []
        var filter = this.validationController.errors.filter(function (t) {
            return t.rule.property.displayName === key;
        });
        if (filter.length == 0) return [];
        var map = filter.map(function (t) {
            return t.message;
        });
        return map;
    }

    IsSelectedItem: boolean;
    get IsShowInput() {
        return this.IsEditing && this.IsSelectedItem;
    }

    SaveOriginalSource(originalSource: any) {

    };

    LoadOriginalSource(originalSource: any, isAdding: boolean) {

    };

    BeginEdit() {
        this.IsEditing = true;

        var keys = Object.keys(this.ChildNodeGroups);
        for (var index = 0; index < keys.length; index++) {
            var childNodes = this.ChildNodeGroups[keys[index]];
            for (var c_index = 0; c_index < childNodes.length; c_index++) {
                var child = childNodes[c_index];
                if (child == null) continue;
                child.BeginEdit();
            }
        }
    };

    ValidateData() {
        this.validationController.validate({ object: this });
    };


    Validate() {
        if (this.validationController.errors.length > 0) {
            return false;
        } else {
            return true;
        }
    }

    CancelEdit() {
        this.IsEditing = false;

        if (this.HasOriginalSource)
            this.LoadOriginalSource(this.OriginalSource, false);

        var childNodes = this.GetChildNode();
        if (childNodes == null || childNodes == 'undefined') {
            childNodes = [];
        }
        for (var index = 0; index < childNodes.length; index++) {
            var editor = childNodes[index];
            if (editor.CancelEdit != null)
                editor.CancelEdit();
        }
    }

    EndEdit() {
        this.IsEditing = false;
        
        var childNodes = this.GetChildNode();
        if (childNodes == null || childNodes == 'undefined') {
            childNodes = [];
        }
        for (var index = 0; index < childNodes.length; index++) {
            var editor = childNodes[index];
            if (editor.EndEdit != null)
                editor.EndEdit();
        }
    }

    EndItemEdit() {
        this.IsItemEditing = false;

        var temp = new Object();
        this.SaveOriginalSource(temp);
        this.SetOriginalSource(temp, !this.HasOriginalSource);
        var childNodes = this.GetChildNode();
        if (childNodes == null || childNodes == 'undefined') {
            childNodes = [];
        }
        for (var index = 0; index < childNodes.length; index++) {
            var editor = childNodes[index];
            if (editor.EndEdit != null)
                editor.EndEdit();
        }
    }

    get errorLength() {
        return this.validationController.errors.length;
    }
}
